// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RxTJ","right":"styles_right__1qS0T"};